import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Autoplay } from "swiper/modules";
import { FaStar } from "react-icons/fa";



const reviews = [
  {
    name: "Rishabh Agarwal",
    location: "Delhi",
    rating: 5,
    review:
      "Wedding Stays made our Jaipur destination wedding truly unforgettable. From venue selection to guest hospitality, everything was handled with elegance and perfection.",
    image:
      "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=50&h=50&crop=faces&fit=crop",
  },
  {
    name: "Shubham Nahata",
    location: "Mumbai",
    rating: 5,
    review:
      "Our Goa beach wedding was beautifully curated by Wedding Stays. The planning was seamless, stress-free, and absolutely magical.",
    image:
      "https://images.unsplash.com/photo-1511367461989-f85a21fda167?w=50&h=50&crop=faces&fit=crop",
  },
  {
    name: "Yash Agarwal",
    location: "Kolkata",
    rating: 5,
    review:
      "The Udaipur palace wedding experience arranged by Wedding Stays felt like a royal fairytale. Every detail was thoughtfully executed.",
    image:
      "https://images.unsplash.com/photo-1544723795-3fb6469f5b39?w=50&h=50&crop=faces&fit=crop",
  },
  {
    name: "Harsh Agarwal",
    location: "Bangalore",
    rating: 4,
    review:
      "From resort booking to event coordination, Wedding Stays ensured a smooth and luxurious wedding experience for us and our guests.",
    image:
      "https://images.unsplash.com/photo-1521119989659-a83eee488004?w=50&h=50&crop=faces&fit=crop",
  },
];



export default function ReviewSection() {
  return (
    <div className="bg-gray-100 text-black py-12">
      <h2 className="text-center font-serif md:text-4xl text-2xl font-semibold mb-8">
        Love Stories Crafted by{" "}
        <span className="text-[#b76d68]"> Wedding Stays</span>
      </h2>
      <div className="max-w-6xl  mx-auto px-8">
        <Swiper
          slidesPerView={1}
          spaceBetween={20}
          loop={true}
          autoplay={{ delay: 4000 }}
          pagination={{ clickable: true }}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          modules={[Pagination, Autoplay]}
          className="mySwiper"
        >
          {reviews.map((review, index) => (
            <SwiperSlide key={index}>
              <div className="bg-white h-[320px] mb-16 p-6 rounded-xl shadow-lg flex flex-col justify-between">
                {/* ⭐ Star Rating */}
                <div>
                  <div className="flex mb-3">
                    {[...Array(5)].map((_, i) => (
                      <FaStar
                        key={i}
                        className={`text-sm ${
                          i < review.rating
                            ? "text-yellow-400"
                            : "text-gray-300"
                        }`}
                      />
                    ))}
                  </div>

                  {/* Review Text */}
                  <p className="text-base leading-relaxed line-clamp-5">
                    “{review.review}”
                  </p>
                </div>

                {/* User Info (Always Bottom) */}
                <div className="flex items-center mt-4">
                  <img
                    src={review.image}
                    alt={review.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div className="ml-3">
                    <p className="font-semibold">{review.name}</p>
                    <p className="text-sm text-gray-500">{review.location}</p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
